import React, { FC, useCallback, useEffect, useState } from 'react';

import { Search, SearchProps } from 'Modules/ui3';


export interface SearchTermProps extends Pick<SearchProps, 'fullWidth' | 'isGray' | 'onChange' | 'inputPropsSx' | 'textFieldPropsSx' | 'placeholder' | 'size'>{
    initialValue?: string;
}

export const SearchTerm: FC<SearchTermProps> = ({ initialValue, onChange, ...props }) => {
    const [value, setValue] = useState('');
    useEffect(() => setValue(initialValue || ''), [initialValue]);
    const change = useCallback((value: string) => {
        setValue(value);
        if (onChange)
            onChange(value);
    }, [onChange]);
    return (
        <Search
            value={value}
            onChange={change}
            {...props}
        />
    );
};
